import {connect} from 'react-redux';
import {TimelineRow} from '../TimelineTypes';
import SubtitleTracksContainer from './SubtitleTracksContainer';
import {
    setSubtitleAction,
    resetSubtitlesAction,
} from './Redux/SubtitleTracksActions';
import {EnabledSubtitles, SubtitlesState} from './Redux/SubtitleTracksReducer';

interface StateProps {
    subtitleTracks: TimelineRow[];
    enabledTracks: EnabledSubtitles;
}

export type State = {
    subtitles: SubtitlesState,
};

export const mapState = (state: State): StateProps => {
    const {subtitles} = state;
    const subtitleTracks: TimelineRow[] = subtitles.subtitles;
    const enabledTracks: EnabledSubtitles = subtitles.enabled;
    
    return {
        subtitleTracks,
        enabledTracks,
    };
};

export const mapDispatch = {
    setSubtitle: setSubtitleAction,
    resetSubtitles: resetSubtitlesAction,
};

export default connect(mapState, mapDispatch)(SubtitleTracksContainer);
